"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var reactstrap_1 = require("reactstrap");
require("../Styles/SafeForm.css");
var SafeForm = /** @class */ (function (_super) {
    __extends(SafeForm, _super);
    function SafeForm(props) {
        return _super.call(this, props) || this;
    }
    SafeForm.prototype.render = function () {
        var _this = this;
        return (React.createElement(reactstrap_1.Row, { className: "SafeForm" },
            React.createElement(reactstrap_1.Col, { className: !this.props.manualEntry ? "faded" : "" },
                !this.props.manualEntry && this.props.currentState === 0 /* Waiting */ && React.createElement("div", { className: "safe-overlay" }, this.props.resources.ScanPackToBegin),
                (this.props.currentState === 3 /* Sending */ || this.props.currentState === 1 /* Scanning */) && React.createElement("div", { className: "safe-overlay" },
                    React.createElement(reactstrap_1.Spinner, { style: { width: '3rem', height: '3rem' } })),
                React.createElement(reactstrap_1.Row, null,
                    React.createElement(reactstrap_1.Col, { md: 6 },
                        React.createElement(reactstrap_1.Label, { for: "productCode", className: !this.props.manualEntry ? "text-muted" : "" }, this.props.resources.ProductCode),
                        React.createElement(reactstrap_1.Input, { type: "text", name: "productCode", id: "productCode", disabled: !this.props.manualEntry, value: this.props.packIdentifier.productCode, onChange: function (e) { return _this.props.onChangeHandler(e); } })),
                    React.createElement(reactstrap_1.Col, { md: 6 },
                        React.createElement(reactstrap_1.Label, { for: "serialNumber", className: !this.props.manualEntry ? "text-muted" : "" }, this.props.resources.SerialNumber),
                        React.createElement(reactstrap_1.Input, { type: "text", name: "serialNumber", id: "serialNumber", disabled: !this.props.manualEntry, value: this.props.packIdentifier.serialNumber, onChange: function (e) { return _this.props.onChangeHandler(e); } }))),
                React.createElement(reactstrap_1.Row, { className: "mt-3" },
                    React.createElement(reactstrap_1.Col, { md: 6 },
                        React.createElement(reactstrap_1.Label, { for: "batchId", className: !this.props.manualEntry ? "text-muted" : "" }, this.props.resources.BatchID),
                        React.createElement(reactstrap_1.Input, { type: "text", name: "batchIdentifier", id: "batchId", disabled: !this.props.manualEntry, value: this.props.packIdentifier.batchIdentifier, onChange: function (e) { return _this.props.onChangeHandler(e); } })),
                    React.createElement(reactstrap_1.Col, { md: 6 }, !this.props.manualEntry &&
                        React.createElement("div", null,
                            React.createElement(reactstrap_1.Label, { key: "expiryDateLable", for: "expiryDate", className: "text-muted" }, this.props.resources.ExpiryDate),
                            React.createElement(reactstrap_1.Input, { key: "expiryDateInput", type: "text", name: "expiry", id: "expiryDate", disabled: true, value: this.props.packIdentifier.expiry })))))));
    };
    return SafeForm;
}(React.Component));
exports.SafeForm = SafeForm;
//# sourceMappingURL=SafeForm.js.map